import type { ReactNode } from 'react';
import styles from './styles.module.css';

export interface ModalFooterProps {
  children: NonNullable<ReactNode>;
}

export function ModalFooter({ children }: ModalFooterProps): ReactNode {
  return <div className={styles.Footer}>{children}</div>;
}
